import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ListFilter } from 'lucide-react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

// Radix SelectItem forbids an empty value, so "no filter" needs a sentinel.
// Underscored so it can't collide with a real department code.
export const ALL_DEPARTMENTS = '__all__';

interface SubmissionsDepartmentFilterProps {
  className?: string;
  departments: Array<string>;
  value: string;
  onValueChange: (value: string) => void;
}

export const SubmissionsDepartmentFilter: FC<
  SubmissionsDepartmentFilterProps
> = ({
  className,
  departments,
  value,
  onValueChange,
}: SubmissionsDepartmentFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <ListFilter className='text-muted-foreground size-4' />
      <Select
        value={value}
        onValueChange={onValueChange}
        disabled={departments.length === 0}>
        <SelectTrigger
          size='sm'
          className='min-w-40 bg-white'
          aria-label={t('submissions.filter.departmentLabel')}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_DEPARTMENTS}>
            {t('submissions.filter.allDepartments')}
          </SelectItem>
          {departments.map((department) => (
            <SelectItem
              key={department}
              value={department}>
              {department}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
